import a from "./ghl-ui.es1506.js";
import o from "./ghl-ui.es1466.js";
function m(r) {
  o(1, arguments);
  var t = a(r), e = Math.floor(t.getMonth() / 3) + 1;
  return e;
}
export {
  m as default
};
